export default {
    defaultConfig: {
        environments: [],
    },

    install(Vue, {environments}) {
        let env = (() => {
            for (let env of environments) {
                let matches = [];
                if (env.host instanceof RegExp) {
                    matches = env.host.exec(window.location.host);
                }
                if (env.host === window.location.host || matches !== null) {
                    return env.callback instanceof Function ? env.callback.apply(null, matches) : env;
                }
            }
            throw "Could not detect environment. Unknown host.";
        })();
        Vue.$env = Vue.prototype.$env = env;
    },
};